import { useField } from 'formik';
import { FormattedMessage } from 'react-intl';

import {
  ErrorMessageStyled,
  FieldWrapperStyled,
  InputLabelStyled,
  InputStyled,
  StarStyled,
} from './FormikInput.styled';

type InputPropsT = {
  name: string;
  label?: string | React.ReactNode;
  type?: string;
  disabled?: boolean;
  isRequired?: boolean;
  children?: React.ReactNode | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
} & React.HTMLAttributes<HTMLInputElement>;

const FormikInput: React.FC<InputPropsT> = ({
  name,
  label,
  disabled,
  isRequired = true,
  type = 'text',
  ...props
}) => {
  const [field, meta] = useField(name);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const error = meta.error as any;
  const isError =
    (isRequired && meta.touched && !meta.value) || (isRequired && meta.touched && error);

  return (
    <FieldWrapperStyled>
      {label && (
        <InputLabelStyled>
          {label} {isRequired && <StarStyled> *</StarStyled>}
        </InputLabelStyled>
      )}

      <InputStyled
        type={type}
        id={name}
        isError={isError}
        disabled={disabled}
        {...props}
        {...field}
      />

      {isError && error && (
        <ErrorMessageStyled>
          <FormattedMessage id={error.id} defaultMessage={error.defaultMessage} />
        </ErrorMessageStyled>
      )}
    </FieldWrapperStyled>
  );
};

export default FormikInput;
